export const appslistTypes = {
  FETCH_APPS_LIST_DATA: 'FETCH_APPS_LIST_DATA',
  FETCH_APPS_LIST_DATA_SUCCESS: 'FETCH_APPS_LIST_DATA_SUCCESS',
  FETCH_APPS_LIST_DATA_FAILURE: 'FETCH_APPS_LIST_DATA_FAILURE',

  SAVE_APPS_LIST_DATA: 'SAVE_APPS_LIST_DATA',
  SAVE_APPS_LIST_DATA_SUCCESS: 'SAVE_APPS_LIST_DATA_SUCCESS',
  SAVE_APPS_LIST_DATA_FAILURE: 'SAVE_APPS_LIST_DATA_FAILURE',

  POST_APPS_LIST_DATA: 'POST_APPS_LIST_DATA',
  POST_APPS_LIST_DATA_SUCCESS: 'POST_APPS_LIST_DATA_SUCCESS',
  POST_APPS_LIST_DATA_FAILURE: 'POST_APPS_LIST_DATA_FAILURE',

  DELETE_APPS_LIST_DATA: 'DELETE_APPS_LIST_DATA',
  DELETE_APPS_LIST_DATA_SUCCESS: 'DELETE_APPS_LIST_DATA_SUCCESS',
  DELETE_APPS_LIST_DATA_FAILURE: 'DELETE_APPS_LIST_DATA_FAILURE',

  MAKE_IS_FETCHING_TRUE: 'MAKE_IS_FETCHING_TRUE',
};
